import Account from "./Account";
import { AccountRole, LocationRoles } from "./Role";
import { UnitSystem } from "./UnitSystem";

export enum UserInviteStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
}

export interface User {
  id?: string;
  email: string;
  isActive?: boolean;
  firstName?: string;
  lastName?: string;
  unitSystem?: UnitSystem;
  phoneMobile?: string;
  phone?: string;
  locale?: string;
  role?: string;
  permission?: string[];
  account?: Account;
  accountRole?: AccountRole;
  locationRoles?: LocationRoles;
  status?: UserInviteStatus;
  enabledFeatures?: string[];
}

export function isEnabledDeveloperMenu(enabledFeatures: string[]): boolean {
  if (
    enabledFeatures &&
    enabledFeatures.find((feature) => feature === "developerMenu")
  ) {
    return true;
  }

  return false;
}

export default User;